import type { Rule } from 'antd/lib/form';

import { SINGAPORE_MOBILE_NUMBER_REGEX, SINGAPORE_PHONE_NUMBER_REGEX } from '@shared/constants/regex';

export const singaporePhoneNumberRule = (required: boolean, message = '') => ({
  message,
  pattern: SINGAPORE_PHONE_NUMBER_REGEX,
  required,
});

export const singaporeMobileNumberRule = (required: boolean, message = '') => ({
  message,
  pattern: SINGAPORE_MOBILE_NUMBER_REGEX,
  required, // TODO: @Jason - required rule is mixed with pattern rule. Same for singaporePhoneNumberRule. Need to refactor this in the future.
});

export const emailRule = (message = ''): Rule => ({
  message,
  type: 'email',
  whitespace: true,
});

export const requiredRule: ({ message, required }: { message?: string; required?: boolean }) => Rule = ({
  message = 'Required',
  required = true,
}) => ({
  message,
  required,
});
